<div>
	<!-- <iframe id="aiFrame" src="http://localhost:8080" name="nault" style=" width: 100%; height: 94vh; " frameborder="0"></iframe> -->
	<iframe id="aiFrame" src="https://xno.social" name="nault" style=" width: 100%; height: 95vh; " frameborder="0"></iframe>
	<!-- <iframe id="aiFrame" src="https://ai.nault.pro" name="nault" style=" width: 100%; height: 95vh; " frameborder="0"></iframe> -->
</div>